import { render } from "./StockResult.vue?vue&type=template&id=678b7170"
import script from "./StockResult.vue?vue&type=script&lang=js"
export * from "./StockResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__